<template>
  <div>
    <pvd-modal ref="screener-modal" id="screener-modal" pvd-modal-width="800" pvd-z-index="9999999">
      <h3 id="screener-modal-heading" class="pvd-modal__heading">
        {{ clientConstants.SCREENER_SELECT_LINK }}
      </h3>
      <p>{{ clientConstants.SCREENER_SELECT.INFO_1 }}</p>
      <p>{{ clientConstants.SCREENER_SELECT.INFO_2 }}</p>
      <p>{{ clientConstants.SCREENER_SELECT.INFO_3 }}</p>
    </pvd-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import { PvdModal } from '@fmr-ap109253/apex-kit/dist/lib/src/pvd';

export default defineComponent({
  name: 'ScreenerModal',
  data: function () {
    return {
      clientConstants: ClientConstants
    };
  },
  methods: {
    openScreenerModal() {
      const screenerModal = this.$refs['screener-modal'] as PvdModal;
      screenerModal.pvdOpen = true;
    }
  }
});
</script>
